$(document).ready(function () {
    $('.product-container .prod-content .tabs-content .tabs-panel').each(function () {
        var html = `<div class="content">${$(this).html()}</div>`;
        var id = $(this).attr('id');
        $('.product-container .prod-content .prod-accordion .tabs-title a').each(function () {
            $(this).attr('role', 'accordian');
            if ($(this).attr('href') == '#'+id) {
                $(this).after(html);
            }
        })
    })

    $('.learn_more').on('click', function(){
      window.location.href = $(this).attr('href');
    });
    $('.product-container .prod-content .tabs-content').remove();
    $('.product-container .prod-content .prod-accordion').removeClass('tabs');
    $('.product-container .prod-content .prod-accordion').removeAttr('data-responsive-accordion-tabs');
    $('.product-container .prod-content .prod-accordion').removeAttr('data-tabs');
    $('.product-container .prod-content .prod-accordion').removeAttr('role');
    $('.product-container .prod-content .accordion-container .prod-accordion .tabs-title > a[role="accordian"]').on('click', function (e){
        e.preventDefault();
        if($(this).parent().hasClass('is-active')) {
            $('.product-container .prod-content .accordion-container .prod-accordion .tabs-title').removeClass('is-active');
            $('.product-container .prod-content .accordion-container:last-child .prod-accordion .tabs-title').addClass('is-active');
        } else {
            $('.product-container .prod-content .accordion-container .prod-accordion .tabs-title').removeClass('is-active')
            $(this).parent().addClass('is-active');
        }
    })

    $('.popup_btn').on('click', function (e) {
        e.preventDefault();
        var id = $(this).data('target');
        $('.popup').removeClass('active');
        $(id).addClass('active');
    });
    $('.popup-header .close').on('click', function (e) {
        e.preventDefault();
        $(this).closest('.popup').removeClass('active')
    })
    $('.popup').on('click', function (e) {
        e.preventDefault();
        if (e.target.closest('.popup-container') == null) {
            $(this).removeClass('active');
        }
    });
    var tabs_left = 3;
    var thumb_container_size = 90;
    $(document).on('click', ".product-container.upsell .product-images .PwzrGrid-container .PwzrGrid-item", function (e) {
        var tabs = $(this).parent().find('.PwzrGrid-item').length;
        var index = $(this).find('[role="button"]').attr('tabindex');
        if((thumb_container_size * tabs) > $('#pwzrswiper-wrapper').height()){
          if ($('.product-container.upsell .product-images .rio-hide-scrollbar').hasClass('bottom')) {
              var left_tabs= tabs - index;
              if (left_tabs <= tabs_left) {
                  console.log(left_tabs);
                  $('.product-container.upsell .product-images .rio-hide-scrollbar').removeClass("bottom");
                  $('.product-container.upsell .product-images .rio-hide-scrollbar').addClass("top");
              }
          } else if($('.product-container.upsell .product-images .rio-hide-scrollbar').hasClass('top')) {
              var left_tabs= index-1;
              if (left_tabs <= tabs_left) {
                  console.log(left_tabs);
                  $('.product-container.upsell .product-images .rio-hide-scrollbar').removeClass('top');
                  $('.product-container.upsell .product-images .rio-hide-scrollbar').addClass('bottom');
              }
          } else {
              var left_tabs= tabs - index;
              if (left_tabs <= tabs_left) {
                  console.log(left_tabs);
                  $('.product-container.upsell .product-images .rio-hide-scrollbar').addClass("top");
              }
          }
        }
        
    })
    $('#shopify-section-promotion-bar').each(function(){
        var time = $(this).find('.promotion-bar-slider').data('time') * 1000
        $(this).find('.promotion-bar-slider').slick({
            infinite: true,
            slidesToShow: 1,
            slidesToScroll: 1,
            speed: 300,
            arrows: true,
            autoplay: true,
            autoplaySpeed: time,
            adaptiveHeight: true
        });
        var $promotion_bar = $(this).find('.promotion-bar');
        $('#shopify-section-header #promotion-bar').append($promotion_bar);
    });
    var $mega_menu = $('.mega-menu-container');
    $('#shopify-section-header').append($mega_menu);
});

$(document).on('click', '.popup .popup-container', function(e){
    e.preventDefault();
    console.log("asdfasdf")
    if ($(window).width() < 768 ) {
        $(this).toggleClass('zoom')
    }
});

$(document).ready(function(){
  $('.blog-service-icons').slick({
    infinite: true,
    slidesToShow: 1,
    slidesToScroll: 1,
    arrows: false,
    dots: false,
    variableWidth: true
  });
});

$(document).ready(function(){
  $('.related-blogs-grid').slick({
    infinite: false,
    slidesToShow: 4,
    slidesToScroll: 1,
    arrows: true,
    dots: false,
    responsive: [
    {
      breakpoint: 1024,
      settings: {
        slidesToShow: 3
      }
    },
    {
      breakpoint: 767,
      settings: {
        slidesToShow: 1.42,
        arrows: false,
      }
    }
  ]
  });
});




$(document).ready(function(){
  $('.product_key_points').slick({
    infinite: false,
    slidesToShow: 3,
    slidesToScroll: 1,
    arrows: true,
    dots: false,
    responsive: [
    {
      breakpoint: 767,
      settings: {
        slidesToShow: 1,
        arrows: true,
        dots: true
      }
    }
  ]
  });
});

/* PDP V3 JS */
$(document).ready(function(){
  $('.row-video-list').slick({
    infinite: false,
    slidesToShow: 5,
    slidesToScroll: 1,
    centerPadding: 35,
    arrows: false,
    dots: false,
    responsive: [
    {
      breakpoint: 1024,
      settings: {
        slidesToShow: 4,
        centerPadding: 48,
      }
    },
    {
      breakpoint: 767,
      settings: {
        slidesToShow: 1,
        slidesToScroll: 1,
        centerMode: true,
        infinite: true,
        centerPadding: "25%",
      }
    }
  ]
  });
});


/* PDP V3 JS */
$(document).ready(function(){
  $('.shopify-video-list').slick({
    infinite: false,
    slidesToShow: 5,
    slidesToScroll: 1,
    centerPadding: 35,
    arrows: false,
    dots: false,
    responsive: [
    {
      breakpoint: 1024,
      settings: {
        slidesToShow: 4,
        centerPadding: 48,
      }
    },
    {
      breakpoint: 767,
      settings: {
        slidesToShow: 1,
        slidesToScroll: 1,
        centerMode: true,
        infinite: true,
        centerPadding: "25%",
      }
    }
  ]
  });
});


document.addEventListener('DOMContentLoaded', function() {
  const stickyBar = document.getElementById('sticky-atc');
  const stickyBtn = document.getElementById('stickyAddToCartBtn');
  const mainAtcBtn = document.querySelector('form[action*="/cart/add"] [type="submit"]');

  if (!stickyBar || !stickyBtn || !mainAtcBtn) return;

  stickyBtn.addEventListener('click', () => mainAtcBtn.click());

  // Delay to ensure widgets exist
  setTimeout(() => {
    const widgetPS = document.getElementById('ps__widget');
    const widgetZTB = document.getElementById('ztb-fbc-tabwrapper');

    function adjustWidgets() {
      if (stickyBar.classList.contains('active')) {
        if (widgetPS) widgetPS.style.bottom = '185px';
        if (widgetZTB) widgetZTB.style.bottom = '135px';
      } else {
        if (widgetPS) widgetPS.style.bottom = '85px';
        if (widgetZTB) widgetZTB.style.bottom = '30px';
      }
    }

    // Handle scroll to activate sticky bar
    window.addEventListener('scroll', function() {
      if (window.scrollY >= 700) {
        stickyBar.classList.add('active');
      } else {
        stickyBar.classList.remove('active');
      }
      adjustWidgets();
    });

    // Initial check
    if (window.scrollY >= 700) stickyBar.classList.add('active');
    adjustWidgets();

  }, 5000); // Delay to ensure widgets load
});


document.addEventListener('DOMContentLoaded', function() {
  window.addEventListener('scroll', function() {
    if (window.scrollY >= 700) {
      document.body.classList.add('pdp-bar-active');
    } else {
      document.body.classList.remove('pdp-bar-active');
    }
  });

  // Initial check (in case page reloads mid-scroll)
  if (window.scrollY >= 700) {
    document.body.classList.add('pdp-bar-active');
  }
});